module.exports = __webpack_public_path__ + "img/bars.51298bee.svg";